import { useCallback } from 'react';
import { AnalyticsBrowser } from '@segment/analytics-next';

import { getCookiebotConsent } from 'app/shared/utils/useCookiebotConsent';

export const useSegmentPage = (
  analytics: AnalyticsBrowser,
  setEventsCalled: (events: string[]) => void
) => {
  return useCallback(
    (title: string) => {
      const cookieConsent = getCookiebotConsent();

      analytics.page(
        title,
        {
          nonInteraction: 1,
        },
        {
          consent: {
            categoryPreferences: {
              necessary: cookieConsent.necessaryConsent,
              preferences: cookieConsent.preferencesConsent,
              statistics: cookieConsent.statisticsConsent,
              marketing: cookieConsent.marketingConsent,
            },
          },
        }
      );
      setEventsCalled([]);
    },
    [analytics]
  );
};
